import Vue from 'vue'
import router from '@/router/index'
import * as Sentry from '@sentry/vue'

export function initSentry (email, env) {
  if (window.Sentry) return
  // 过滤声网 SDK 内部 reportPCStats 在连接销毁后仍执行的竞态报错（this.connection.isPreallocation 读取 undefined） [Claude Code]
  const ignoreError = ['Loading CSS chunk', 'NotSupportedError', 'NotAllowedError', 'InvalidStateError', 'SecurityError', 'AgoraRTCError', 'RTCPeerConnection', 'InternalError', 'Network Error', 'ResizeObserver', 'Window', 'Failed', 'rejection', 'captured', 'resume', 'aborted', '401', '403', '404', '500', '504', 'isPreallocation']
  if (window.location.host == 'mediahub.tvunetworks.com') {
    Sentry.init({
      Vue,
      dsn: 'https://fd12a5067714f30a99f5de31a7a7a80b@o982456.ingest.us.sentry.io/4505876725891072',
      ignoreErrors: [
        // Random plugins/extensions
        'top.GLOBALS',
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'http://tt.epicplay.com',
        "Can't find variable: ZiteReader",
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        // Facebook borked
        'fb_xd_fragment',
        // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
        // reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        'conduitPage'
      ],
      denyUrls: [
        // Google Analytics
        /.*\.google-analytics\.com/i,
        // Hotjar，匹配任何以 .hotjar 结尾的域
        /.*\.hotjar/i,
        // HubSpot，匹配任何以 hubspot.com 结尾的域
        /.*\.hubspot\.com/i,
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
      ],
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration()
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
      environment: env,
      release: localStorage.getItem('mediaHubVersion'),
      // 关闭 Vue 组件级 span 追踪：开启后每次 WS 推送/数据刷新会让所有在屏组件产生 mount/render/update 三类 span，
      // 轻易撞 1000 span/transaction 上限被 drop，导致 Sentry 侧出现海量 invalid spans（实测 166k） [Claude Code]
      trackComponents: false,
      tracePropagationTargets: ['mediahub.tvunetworks.com', /^\//],
      // replaysSessionSampleRate: 0.1,
      // replaysOnErrorSampleRate: 0.1,
      beforeSend (event, hint) {
        const error = hint.originalException
        if (error && error.message) {
          let flag = false
          for (const err of ignoreError) {
            if (error.message.indexOf(err) > -1) {
              flag = true
              break
            }
          }
          if (flag) {
            return null
          }
        }
        return event
      }
    })
    Sentry.setUser({ email })
    window.Sentry = Sentry
  }
}
